var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaindashbaorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.333 4.333)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    transform: "translate(-0.333 -0.333)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.537,10.589V6.178A1.165,1.165,0,0,0,9.372,5.014H6.127A1.165,1.165,0,0,0,4.962,6.178V9.424a1.165,1.165,0,0,0,1.165,1.165Zm-4.41-7.9H9.372a3.494,3.494,0,0,1,3.494,3.494v5.575A1.165,1.165,0,0,1,11.7,12.918H6.127A3.494,3.494,0,0,1,2.632,9.424V6.178A3.494,3.494,0,0,1,6.127,2.684ZM17.081,4.765v5.824H22.9A1.165,1.165,0,0,0,24.07,9.424V4.765A1.165,1.165,0,0,0,22.9,3.6H18.246A1.165,1.165,0,0,0,17.081,4.765ZM22.9,1.27A3.494,3.494,0,0,1,26.4,4.765V9.424A3.494,3.494,0,0,1,22.9,12.918H15.916a1.165,1.165,0,0,1-1.165-1.165V4.765A3.494,3.494,0,0,1,18.246,1.27ZM17.081,16.944V21.36a1.165,1.165,0,0,0,1.165,1.165H21.5a1.165,1.165,0,0,0,1.165-1.165V18.109A1.165,1.165,0,0,0,21.5,16.944ZM21.5,24.855H18.246a3.5,3.5,0,0,1-3.494-3.494V15.779a1.165,1.165,0,0,1,1.165-1.165H21.5a3.5,3.5,0,0,1,3.494,3.494V21.36A3.5,3.5,0,0,1,21.5,24.855Zm-10.94-7.911H4.734a1.165,1.165,0,0,0-1.165,1.165v4.659a1.165,1.165,0,0,0,1.165,1.165H9.393a1.165,1.165,0,0,0,1.165-1.165ZM4.734,26.262a3.494,3.494,0,0,1-3.494-3.494V18.109a3.494,3.494,0,0,1,3.494-3.494h6.989a1.165,1.165,0,0,1,1.165,1.165v6.989a3.494,3.494,0,0,1-3.495,3.494Z",
    transform: "translate(0.582 0.209)",
    fill: "#0fa9a6",
    stroke: "#0fa9a6",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaindashbaorIcon);
export default __webpack_public_path__ + "static/media/maindashbaor-icon.e586f7cdae8cb50b6dd0f0256c1698a8.svg";
export { ForwardRef as ReactComponent };